import { BaseSearchDTO } from "../baseSearchDTO.interface";

export interface SearchSearchDTO extends BaseSearchDTO {
  filters?: {
    customerId?: string;
  }
}
